import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const uz: AppStrings = {
  // COMMON
  error_title: 'Xato',
  cancel: 'Bekor qilish',
  retry: 'Qayta urinish',
  back_arrow: '← Orqaga',

  // ASK SCREEN
  ask_box_unavailable: 'Quti mavjud emas',
  ask_box_unavailable_desc: 'Havola eskirgan yoki egasi qutini yopgan boʻlishi mumkin.',
  ask_create_own_box: 'Oʻz qutingni yaratish',
  ask_sent_title: 'Yuborildi ✅',
  ask_sent_desc: 'Anonim savol quti egasiga yetdi.',
  ask_anonymous_hint: 'Savoling anonim tarzda yuboriladi.',
  ask_placeholder: 'Savolni yoz…',
  ask_send: 'Yuborish',
  ask_sending: 'Yuborilmoqda…',
  ask_error_rate_limit: 'Juda tez-tez, bir daqiqa kuting.',
  ask_error_restart: 'Mini App-ni qayta ishga tushiring.',
  ask_error_load: 'Qutini yuklab boʻlmadi.',
  ask_error_send: 'Savolni yuborib boʻlmadi.',
  ask_error_banned: 'Siz ilovada bloklangansiz.',
  ask_banned_appeal_btn: 'Shikoyat qilish',
  ask_appeal_sent: 'Shikoyat yuborildi. Uni qoʻlda koʻrib chiqamiz.',

  // AGE GATE
  age_gate_title: 'Faqat 18+ uchun',
  age_gate_desc:
    'Siz anonim savol yuboryapsiz. Hurmat bilan munosabatda boʻling: taʼqib, tahdid, voyaga yetmaganlarga oid jinsiy kontent va qonunni buzadigan har qanday kontent taqiqlanadi. Anonimlik jazosizlikni anglatmaydi — qoidabuzarliklar moderatsiyaga yuboriladi. Savol yuborish orqali siz 18 yoshda ekanligingizni tasdiqlaysiz va qoidalarni qabul qilasiz.',
  age_gate_confirm: 'Menga 18 bor — davom etish',

  // INBOX SCREEN
  inbox_title: 'Savollar qutisi',
  box_link_accordion: 'Taklif havolasi',
  inbox_notifications_ask: '🔔 Botga yangi savollar haqida bildirishnoma yuborishga ruxsat berish?',
  inbox_notifications_allow: 'Ruxsat berish',
  inbox_notifications_dismiss_label: 'Yopish',
  inbox_box_toggle_disable: 'Qabulni oʻchirish',
  inbox_box_toggle_enable: 'Qabulni yoqish',
  inbox_box_disabled_warning: 'Savollar qabuli oʻchirildi — yangi savollar qabul qilinmaydi.',
  inbox_share_hint: 'Havolani ulash — doʻstlaring sanga anonim savollar bera oladi.',
  inbox_copy: 'Nusxalash',
  inbox_copied: 'Nusxalandi',
  inbox_copy_error: 'Xato',
  inbox_no_deeplink: 'Havola deploy-dan keyin paydo boʻladi.',
  inbox_invite_story: 'Story orqali taklif qilish',
  inbox_invite_chat: 'Chat orqali taklif qilish',
  inbox_card_rendering: 'Taklif kartasi hali tayyorlanmoqda.',
  inbox_story_unsupported:
    'Story Telegram-ning ushbu versiyasida mavjud emas. «Chat orqali» ni sinab koʻr.',
  inbox_story_error: 'Story-ni ochib boʻlmadi.',
  inbox_chat_unsupported:
    'Chat orqali ulashish Telegram-ning ushbu versiyasida mavjud emas. Klientni yangilang.',
  inbox_chat_error: 'Ulashib boʻlmadi. Qayta urinib koʻr.',
  inbox_chat_prepare_error: 'Taklifni tayyorlab boʻlmadi.',
  inbox_filter_incoming: 'Kiruvchi',
  inbox_filter_hidden: 'Yashirilgan',
  inbox_filter_blocked: 'Bloklangan',
  inbox_filter_empty: 'Bu yerda hali hech narsa yoʻq.',
  inbox_acc_unanswered: 'Javobsiz',
  inbox_acc_answered: 'Javob berilgan',
  inbox_acc_hidden: 'Yashirilgan',
  inbox_acc_blocked: 'Bloklangan',
  inbox_empty: 'Hali savol yoʻq. Yuqoridagi havolani ulash.',
  inbox_load_more: 'Koʻproq yuklash',
  inbox_load_more_error: 'Keyingi sahifani yuklab boʻlmadi.',
  inbox_error_load: 'Qutini yuklab boʻlmadi.',
  inbox_rate_limit: 'Juda tez-tez, bir daqiqa kuting.',
  inbox_toggle_error: 'Quti holatini oʻzgartirib boʻlmadi.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Menga anonim tarzda yoz',
  message_placeholder: 'Xabar yoz…',
  message_anonymous_hint: 'Xabaring anonim tarzda yuboriladi.',
  message_sent_title: 'Yuborildi ✅',
  message_sent_desc: 'Anonim xabaring yetkazildi.',
  message_owner_entry: 'Menga yoz',
  message_share_hint: 'Havolani ulash — istalgan kishi senga anonim xabar yubora oladi.',
  message_inbox_open: 'Qabul qilingan xabarlar',
  message_inbox_title: 'Xabarlar',
  message_inbox_empty: 'Hali xabar yoʻq. Yuqoridagi havolangni ulash.',

  // ANSWER SCREEN
  answer_title: 'Savolga javob',
  answer_placeholder: 'Javobni yoz…',
  answer_submit: 'Yuborish',
  answer_submitting: 'Yuborilmoqda…',
  answer_back: 'Orqaga',
  answer_error_send: 'Javobni yuborib boʻlmadi.',

  // SHARE SCREEN
  share_title: 'Javob eʼlon qilindi ✅',
  share_hint: 'Kartani ulash va yanada koʻproq savol yigʻish.',
  share_card_rendering_desc:
    'Karta hali tayyorlanmoqda. Savollarga qayt va biroz keyin tekshir — Story yoki chatda ulasha olasan.',
  share_card_alt: 'Javob kartasi',
  share_story_btn: 'Story-da ulashish',
  share_story_btn_busy: 'Ochilmoqda…',
  share_chat_btn: 'Chatda ulashish',
  share_chat_btn_busy: 'Tayyorlanmoqda…',
  share_back: 'Savollarga qaytish',
  share_story_unsupported:
    'Story Telegram-ning ushbu versiyasida mavjud emas. «Chatda ulashish» ni sinab koʻr.',
  share_story_error: 'Story-ni ochib boʻlmadi. «Chatda ulashish» ni sinab koʻr.',
  share_chat_sent: 'Xabar yuborildi.',
  share_chat_unsupported:
    'Chat orqali ulashish Telegram-ning ushbu versiyasida mavjud emas. Klientni yangilang.',
  share_chat_error: 'Ulashib boʻlmadi. Qayta urinib koʻr.',
  share_chat_prepare_error: 'Xabarni tayyorlab boʻlmadi.',

  // LEADERBOARD SCREEN
  lb_title: 'Reyting',
  lb_period_7d: '7 kun',
  lb_period_30d: '30 kun',
  lb_period_all: 'Barcha vaqt',
  lb_group_label: 'Kategoriya',
  lb_group_all: 'Barchasi',
  lb_group_ask: 'Savollar',
  lb_group_rate: 'Baholar',
  lb_group_confession: 'Eʼtiroflar',
  lb_group_guesswho: 'Kim ekanini top',
  lb_group_message: 'Xabarlar',
  lb_error: 'Reytingni yuklab boʻlmadi',
  lb_empty: 'Reytingda hali hech kim yoʻq',
  lb_anon: 'Anonim',
  lb_load_more: 'Koʻproq yuklash',
  lb_questions: (n) => `${n} sav.`,
  lb_referrals: (n) => `${n} ref.`,

  // REWARDS SCREEN
  rw_title: 'Mening mukofotlarim',
  rw_error: 'Mukofotlarni yuklab boʻlmadi',
  rw_level: (n) => `${n}-daraja`,
  rw_confirmed_referrals: (n) =>
    plural('uz', n, {
      one: '{n} tasdiqlangan referral',
      other: '{n} tasdiqlangan referral',
    }),
  rw_next_level_section: (n) =>
    plural('uz', n, {
      one: 'KEYINGI DARAJA — {n} referral',
      other: 'KEYINGI DARAJA — {n} referral',
    }),
  rw_to_level: (level, target) => `${level}-darajaga: ${target}`,
  rw_max_level: 'Maksimal daraja erishildi!',
  rw_badges_section: 'NISHONLAR',
  rw_formats_section: 'QUTI FORMATLARI',

  // QUESTION CARD
  qcard_status_new: 'Yangi',
  qcard_status_hidden: 'Yashirilgan',
  qcard_status_answered: 'Javob berildi',
  qcard_moderation_flagged: 'Ehtiyot boʻl: shubhali xabar',
  qcard_answer_btn: 'Javob berish',
  qcard_answer_send: 'Yuborish',
  qcard_share_btn: 'Ulashish',
  qcard_hide_btn: 'Yashirish',
  qcard_show_btn: 'Koʻrsatish',
  qcard_report_btn: 'Shikoyat qilish',
  qcard_block_btn: 'Bloklash',
  qcard_unblock_btn: 'Blokdan chiqarish',
  qcard_report_reason_label: 'Shikoyat sababini tanlang:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Taʼqib',
  qcard_reason_sexual: 'Jinsiy kontent',
  qcard_reason_other: 'Boshqa',
  qcard_error_hide: 'Koʻrinishni oʻzgartirib boʻlmadi.',
  qcard_error_report: 'Shikoyatni yuborib boʻlmadi.',
  qcard_error_block: 'Yuboruvchini bloklab boʻlmadi.',
  qcard_report_done: 'Shikoyat yuborildi — rahmat.',
  qcard_block_done: 'Yuboruvchi bloklandi.',
  qcard_unblock_done: 'Yuboruvchi blokdan chiqarildi.',

  // ERRORS
  err_network: 'Serverga ulanish yoʻq. Internetni tekshiring va qayta urinib koʻring.',
  err_server_unavailable: 'Server vaqtincha mavjud emas, keyinroq urinib koʻring.',
  err_internal: 'Nimadir notoʻgʻri ketdi. Biz bilymiz — keyinroq urinib koʻring.',
  err_bad_request: 'Kiritilgan maʼlumotlarni tekshiring.',
  err_generic: 'Amalni bajarib boʻlmadi, keyinroq urinib koʻring.',
  err_schema: 'Maʼlumotlar xatosi. Ilovani yangilab koʻring.',
  share_story_link_premium_note:
    'Story-dagi havolani Telegram faqat Premium bilan beradi. Usiz ham doʻstlaring seni topadi — username kartada koʻrinadi.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Kirish xatosi',
  auth_error_desc:
    'Autentifikatsiya amalga oshmadi. Mini App-ni Telegram orqali yopib, qayta oching.',

  // REWARD TOAST
  reward_toast_title: 'Yangi mukofot!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Savollar',
  tab_leaderboard: 'Reyting',
  tab_rewards: 'Mukofotlar',
  tab_settings: 'Sozlamalar',

  // SETTINGS SCREEN
  settings_title: 'Sozlamalar',
  settings_section_general: 'Umumiy',
  settings_notifications: 'Yangi savollar haqida bildirishnomalar',
  settings_notifications_hint: 'Bot sanga savol berilganda xabar yuboradi.',
  settings_notifications_error: 'Bildirishnoma sozlamasini saqlash mümkin boʻlmadi.',
  settings_language: 'Til',
  settings_language_error: 'Tilni oʻzgartirib boʻlmadi. Qayta urinib koʻr.',
  settings_section_about: 'Ilova haqida',
  settings_version: 'Versiya',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story havolasi — faqat Premium uchun',
  code_modal_explain:
    'Telegram Story-da klikaberl havolani faqat Premium abonentlariga beradi. Lekin Story-ga oʻz kodingni qoʻshishingiz mumkin — tomoshabinlar uni ilovaga kiritib, sizga anonim savol beradi.',
  code_modal_your_code: 'Sening koding',
  code_modal_copy: 'Kodni nusxalash',
  code_modal_copied: 'Nusxalandi',
  code_modal_share_btn: 'Story-da ulashish',
  code_modal_loading: 'Kod olinmoqda…',
  code_modal_error: 'Kodni olib boʻlmadi. Keyinroq urinib koʻring.',
  ask_code_title: 'Kodni kiriting',
  ask_code_desc:
    'Story-dan oʻtdingmi? Undagi kodni toping (masalan, 1234) va pastga kiriting.',
  ask_code_placeholder: 'Story-dagi kod',
  ask_code_find: 'Topish',
  ask_code_not_found: 'Kod topilmadi. Raqamlarni tekshirib, qayta urining.',
  ask_code_invalid: 'Kod 4 raqamdan iborat.',
  code_onboarding_header: 'Story-dan keldingmi?',
  code_onboarding_text: 'Doʻstingning kodini kiriting va unga anonim savol bering.',
  code_onboarding_action: 'Kodni kiriting',
  settings_ask_by_code: 'Kod orqali soʻrash',
  settings_my_code_title: 'Story uchun koding',
  settings_my_code_hint:
    'Bu kodni Story-ga yozing — tomoshabinlar uni kiritib, sizga anonim savol beradi. Telegram klikaberl havolani Story-da faqat Premium abonentlariga beradi.',
  settings_my_code_rotate: 'Yangi kod olish',
  settings_my_code_rotating: 'Yangilanmoqda…',
  settings_my_code_done: 'Kod yangilandi',
  settings_my_code_error: 'Kodni olib boʻlmadi.',
  settings_my_code_rotate_confirm_title: 'Kodni almashtiramizmi?',
  settings_my_code_rotate_confirm_desc:
    'Eski koding shu zahoti ishlamay qoladi. Story\'ngda uni koʻrganlar endi senga yoza olmaydi. Faqat kimdir spam qilayotgan boʻlsa almashtir.',
  settings_my_code_rotate_confirm_action: 'Kodni almashtirish',

  // BOT
  bot_greeting: (name) => (name ? `Salom, ${name}! 👋` : 'Salom! 👋'),
  bot_onboarding:
    'Bu VeylMe — anonim savollar.\n\n' +
    'Mini App-ni ochib, Story-ga «Menga anonim savol ber» kartochkasini joylash — ' +
    'va anonim savollarni to\'g\'ridan-to\'g\'ri shu yerda qabul qil.\n\n' +
    '⚠️ 18+. Hurmatli bo\'l: tahqirlash, tahdid va taqiqlangan kontent ' +
    'ruxsat etilmaydi. Anonimlik ≠ jazosizlik — qoidabuzarliklar moderatsiyaga yuboriladi.',
  bot_open_btn: 'VeylMe-ni ochish',
  notify_answer_btn: 'Javob berish',
  bot_invite_text:
    'Kimdir VeylMe havolasini ulashdi.\n\n' +
    'Anonim savol berish uchun Mini App-ni och:',
  bot_invite_btn: 'Anonim so\'rash',

  // WORK-027 i18n sweep
  tagline: 'Menga anonim savol ber',
  share_ask_action: 'Soʻrash',
  share_answered_text: 'Men anonim savolga javob berdim 👀',
  err_not_in_telegram: 'Mini App Telegram ichida ishlamayapti. Ilovani qayta ishga tushiring.',
  badge_viral_starter: 'Viral start',
  badge_storyteller: 'Hikoyachi',
  badge_loop_master: 'Sikl ustasi',
  theme_confession: 'Eʼtiroflar',
  theme_guesswho: 'Kim ekanini top',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Savol',
  card_label_answer: 'Javob',
  card_invite_subtitle: 'anonim, roʻyxatdan oʻtmasdan',
  card_code_hint: 'ILOVAGA KODNI KIRITING',
  share_msg_title: (brand) => `${brand} · Anonim savollar`,
  notify_new_question: '🔔 Sizga anonim savol berildi',
  notify_unanswered_reminder: (n) =>
    plural('uz', n, {
      one: '🔔 Sizda {n} javobsiz savol bor',
      other: '🔔 Sizda {n} javobsiz savol bor',
    }),
  notify_ban_permanent: 'butunlay',
  notify_ban_until: (date) => `${date} gacha`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Siz VeylMe-da ${untilPhrase} bloklandingiz. Juda koʻp qabul qiluvchi xabarlaringizdan shikoyat qildi.\nBu xato deb hisoblasangiz, ilovada apellyatsiya yuborishingiz mumkin.`,
  notify_warning_msg:
    '⚠️ Bir nechta qabul qiluvchi xabarlaringizdan shikoyat qildi. Yana bir oz — va siz VeylMe-da bloklanasiz.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Mening savollarim',
  my_questions_empty_title: 'Siz hali savol bermadingiz',
  my_questions_empty_desc: 'Kimningdir qutisiga savol bering — javob shu yerda ko\'rinadi.',
  my_questions_loading: 'Javob tekshirilmoqda…',
  my_questions_waiting: 'Javob kutilmoqda',
  my_questions_answer_label: 'Javob',
  settings_my_questions: 'Mening savollarim',
  ask_sent_find_reply_hint: 'Javobni keyinroq «Mening savollarim»da topishingiz mumkin.',
  inbox_story_nonpremium_hint: 'Telegram Premiumsiz Story havolasi bosilmaydi, shuning uchun kod ko\'rsatamiz — chatga ulashish ishonchliroq.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram ruxsatnomasining muddati tugagan',
  session_expired_desc: 'Telegram ilovaga ruxsatnomani faqat ishga tushirishda bir marta beradi, bunisining muddati esa allaqachon tugagan. Ilovani qaytadan oching — boshlagan matningizni saqlab qo\'ydik.',
  session_expired_desc_no_storage: 'Telegram ruxsatnomangiz muddati tugadi, ilovani qaytadan ochish kerak. Kiritgan matningizni saqlab bo\'lmadi — chiqishdan oldin uni nusxalab oling.',
  session_expired_reopen: 'Qaytadan ochish',
  session_expired_stuck_title: 'Telegram o\'sha eski ruxsatnomani qaytardi',
  session_expired_stuck_desc: 'Ilovani bot menyusi orqali butunlay yoping va qaytadan oching — shunda Telegram yangi ruxsatnoma beradi.',
  session_auth_failed_title: 'Kirishni tasdiqlab bo\'lmadi',
  session_auth_failed_desc: 'Telegram ilovaga kirishingizni tasdiqlamadi. Ilovani yoping va bot bilan suhbatdan qaytadan oching.',
  session_expired_manual_close: 'Ilova bu yerda o\'zini yopa olmaydi — uni o\'zingiz yoping va bot bilan suhbatdan qaytadan oching.',
  session_expiring_soon: 'Telegram ruxsatnomasining muddati tez orada tugaydi. Hech narsa yo\'qolmasligi uchun ilovani qaytadan oching.',
  my_questions_check_failed: 'Javoblarni tekshirib bo\'lmadi. Keyinroq urinib ko\'ring.',
  settings_notifications_load_error: 'Sozlamani yuklab bo\'lmadi.',
};
